module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "page-nav",
    attrs: {
      "aria-label": "Page navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination justify-content-center"
  }, [_c('li', {
    staticClass: "page-item",
    class: _vm.prevStyle
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#",
      "aria-label": "Previous"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onPageSelected(_vm.current - 1)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("«")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous")])])]), _vm._v(" "), _vm._l((_vm.max), function(p) {
    return _c('li', {
      staticClass: "page-item",
      class: p === _vm.current ? 'disabled' : '',
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onPageSelected(p)
        }
      }
    }, [_c('a', {
      staticClass: "page-link",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(p))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "page-item",
    class: _vm.nextStyle
  }, [_c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onPageSelected(_vm.current + 1)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("»")]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next")])])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-462f495f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageNav.vue
// module id = 83
// module chunks = 1 2